import { dataHooks } from '../../../../../libs/dataHooks';

export const templateVideoDataHooks = dataHooks<{
  video;
  loader;
  videoSource;
}>('template-video');
